<!--
 * @Author: cryi.liu
 * @Date: 2020-07-13 11:44:42
 * @LastEditTime: 2020-07-16 17:49:01
 * @Description: 根据 Scope 添加考试对象
-->
<template>
  <div class="add-exam-object-by-scope">
    <div class="action-bar">
      <div>
        <span>用户类型：</span>
        <i-select v-model="userType" size="small" style="width: 120px;">
          <i-option value="ThirdPart">第三方员工</i-option>
          <i-option value="NoThirdPart">非第三方员工</i-option>
        </i-select>
      </div>
      <div>
        <pss-button text="添加" @on-click="addExamObjectByScopeHandler" />
      </div>
    </div>
    <div class="user-filter-container">
      <keep-alive>
        <component :is="currentCom" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import AddThirdPartyUser from './AddThirdPartyUser.vue';
import AddNoThirdPartyUser from './AddNoThirdPartyUser.vue';

export default {
  name: 'AddExamObjectByScope',
  props: {
    examId: { type: [Number, String], required: false },
  },
  data() {
    return {
      // 可选值 ThirdPart | NoThirdPart
      userType: 'ThirdPart',
      currentCom: null,
    };
  },
  computed: {
    ...mapGetters({
      token: 'authStore/token',
      paperId: 'createPaperStore/paperId',
      thirdPartyUserRule: 'createPaperStore/thirdPartyUserRule',
      noThirdPartyUserRule: 'createPaperStore/noThirdPartyUserRule',
    }),
    thirdPart() {
      return this.userType === 'ThirdPart';
    },
  },
  watch: {
    userType: {
      immediate: true,
      handler(userType) {
        if (userType === 'ThirdPart') {
          this.currentCom = AddThirdPartyUser;
        } else if (userType === 'NoThirdPart') {
          this.currentCom = AddNoThirdPartyUser;
        }
      },
    },
  },
  methods: {
    ...mapActions({
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setExamObjectList: 'createPaperStore/invokeSetExamObjectList',
      setExamObjectTotal: 'createPaperStore/invokeSetExamObjectTotal',
      setCanAddExamObject: 'createPaperStore/invokeSetCanAddExamObject',
    }),
    /**
     * 通过 Scope 添加考试对象处理函数
     */
    addExamObjectByScopeHandler() {
      this.requestAddExamObjectByScopeAndSetting();
    },
    /**
     * 请求通过 Scope 添加考试对象并设置
     */
    requestAddExamObjectByScopeAndSetting() {
      this.setProcessingShowState({ show: true });

      this.requestAddExamObjectByScope()
        .then(() => {
          this.setCanAddExamObject({ canAddExamObject: false });

          this.requestGetExamObject()
            .then((subResult) => {
              this.setExamObjectTotal({ examObjectTotal: subResult.total });

              const { list } = subResult;

              list.forEach((item) => {
                if (item.dispatched) {
                  item.staffType = '第三方员工';

                  if (!item.branch) {
                    item.branch = '所有分公司';
                  }

                  if (!item.subBranch) {
                    item.subBranch = '所有办事处';
                  }

                  if (!item.channel) {
                    item.channel = '所有渠道';
                  }

                  if (!item.compoChannel) {
                    item.compoChannel = '所有小渠道';
                  }

                  if (!item.userType) {
                    item.userType = '所有';
                  }

                  if (!item.userTypeDetail) {
                    item.userTypeDetail = '所有';
                  }

                  if (!item.starLevel) {
                    item.starLevel = '所有';
                  }

                  if (!item.mainGroup) {
                    item.hrMainGroup = '所有主营产品';
                  }

                  if (!item.groupName) {
                    item.groupName = '--';
                  }
                } else {
                  item.staffType = '非第三方员工';

                  if (!item.branch) {
                    item.branch = '所有分公司';
                  }

                  if (!item.subBranch) {
                    item.subBranch = '所有办事处';
                  }

                  if (!item.channel) {
                    item.channel = '所有渠道';
                  }

                  if (!item.compoChannel) {
                    item.compoChannel = '所有小渠道';
                  }

                  if (!item.userType) {
                    item.userType = '--';
                  }

                  if (!item.userTypeDetail) {
                    item.userTypeDetail = '--';
                  }

                  if (!item.starLevel) {
                    item.starLevel = '--';
                  }

                  if (!item.mainGroup) {
                    item.hrMainGroup = '--';
                  }

                  if (!item.groupName) {
                    item.groupName = '所有用户组';
                  }
                }
              });

              this.setExamObjectList({ examObjectList: list });
              this.setProcessingShowState({ show: false });
            })
            .catch((subResult) => {
              alert(subResult.msg);
              this.setProcessingShowState({ show: false });
            });
        })
        .catch((result) => {
          alert(result.msg);
          this.setProcessingShowState({ show: false });
        });
    },
    /**
     * 请求通过 Scope 添加考试对象
     */
    requestAddExamObjectByScope() {
      let params = {};

      if (this.thirdPart) {
        const thirdPartyUserRule = JSON.parse(JSON.stringify(this.thirdPartyUserRule));
        Object.keys(thirdPartyUserRule).forEach((key) => {
          if (thirdPartyUserRule[key] === 'all') {
            thirdPartyUserRule[key] = '';
          }
        });
        params = thirdPartyUserRule;
      } else {
        const noThirdPartyUserRule = JSON.parse(JSON.stringify(this.noThirdPartyUserRule));
        Object.keys(noThirdPartyUserRule).forEach((key) => {
          if (noThirdPartyUserRule[key] === 'all') {
            noThirdPartyUserRule[key] = '';
          }
        });
        params = noThirdPartyUserRule;
      }

      params.paperId = this.paperId;
      params.examId = this.examId;
      params.thirdPart = this.thirdPart;

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateAddExamObject(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求获取考试对象列表
     */
    requestGetExamObject() {
      return new Promise(async (resolve, reject) => {
        const result = await axios.get(`/examcentersite/paper/${this.paperId}/scope`, { headers: { psstoken: this.token } });

        if (result.data.code === '200') {
          resolve(result.data.data);
        } else {
          reject(result.data.data);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-exam-object-by-scope {
  width: 100%;

  > .action-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;

    > div {
      flex: 0 0 calc(100% / 4);
      width: calc(100% / 4);
    }
  }
}
</style>
